import { render, staticRenderFns } from "./FeedPage.vue?vue&type=template&id=42b6614c&scoped=true&"
import script from "./FeedPage.vue?vue&type=script&lang=js&"
export * from "./FeedPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedPage.vue?vue&type=style&index=0&id=42b6614c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b6614c",
  null
  
)

export default component.exports